import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";

const Modal = ({
  id,
  open,
  setOpen,
  children,
  title,
  className,
  dismissible = true,
  overlayChildren,
  removePadding = false,
}) => {
  const modalRef = useRef(null);

  const closeModal = () => setOpen(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const handleEsc = (event) => {
      if (event.key === "Escape" || event.key === "Esc") {
        closeModal();
      }
    };
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, [open]);

  return (
    open &&
    createPortal(
      <ModalContainerWrapper
        id="font-lexend"
        ref={modalRef}
        aria-hidden="true"
        open={open}
      >
        {overlayChildren}
        <ModalContainer className={className}>
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
            {dismissible && (
              <CloseIconContainer onClick={closeModal}>
                <CloseIcon
                  style={{
                    fontSize: 28,
                  }}
                />
              </CloseIconContainer>
            )}
          </ModalHeader>
          <ModalBody removePadding={removePadding}>{children}</ModalBody>
        </ModalContainer>
        <ModalBackdrop onClick={closeModal}></ModalBackdrop>
      </ModalContainerWrapper>,
      document.body
    )
  );
};

export default Modal;

export const ModalBody = styled.div`
  padding: ${({ removePadding }) => (removePadding ? "0" : "20px")};
`;

export const ModalContainerWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 30;
  margin-top: 70px;
  display: ${({ open }) => (open ? "flex" : "none")};
  height: calc(100vh - 70px);
  align-items: end;
  justify-content: center;
  overflow: hidden;

  @media (min-width: 640px) {
    align-items: center;
  }
`;

export const ModalTitle = styled.div`
  font-size: 20px !important;
  font-weight: 500;
  line-height: 28px;
`;

export const CloseIconContainer = styled.div`
  cursor: pointer;
  display: grid;
  place-items: center;
  height: max-content;
`;

export const ModalBackdrop = styled.div`
  position: absolute;
  inset: 0;
  z-index: 40;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  width: 100%;
  height: 100%;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #e8e8e8;
`;

export const ModalContainer = styled.div`
  position: relative;
  z-index: 50;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
  border-radius: 20px;
  background-color: #ffffff;
  transform: translateY(0);
  transition: transform 0.3s;
`;
